module.exports = "### Hello, World!\n\nLet’s dive right in and build our first element.\n\n- React just a library, easy to get going\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/notes_1.md
// module id = 1471
// module chunks = 0